import React from "react";

const Counts = (props: any) => {

    return (
        <section id="counts" className="counts">
            <div className="container">

                <div className="row counters">

                    <div className="col-lg-3 col-6 text-center">
                        <span className="purecounter">232</span>
                        <p>Clients</p>
                    </div>

                    <div className="col-lg-3 col-6 text-center">
                        <span className="purecounter">521</span>
                        <p>Projects</p>
                    </div>

                    <div className="col-lg-3 col-6 text-center">
                        <span className="purecounter">1463</span>
                        <p>Hours Of Support</p>
                    </div>

                    <div className="col-lg-3 col-6 text-center">
                        <span className="purecounter">15</span>
                        <p>Hard Workers</p>
                    </div>

                </div>

            </div>
        </section>
    )

}

export default Counts;
